import { WithdrawalAdminPath, WithdrawalAdminTitle } from "@/entities";
import {
  AdminWithdrawalsAlert,
  AdminWithdrawalsButtons,
  AdminWithdrawalsList,
} from "@/features";
import { AdminBreadcrumb, AdminTitle } from "@/shared";

export function AdminWithdrawalListPage() {
  return (
    <>
      <div className="d-flex align-items-center">
        <div>
          <AdminBreadcrumb items={WithdrawalAdminPath} />
          <AdminTitle title={WithdrawalAdminTitle} />
        </div>
        <div className="ms-auto"></div>
      </div>

      <AdminWithdrawalsAlert />
      <AdminWithdrawalsButtons />

      <AdminWithdrawalsList />
    </>
  );
}
